/*
* params
* bookRate: final price that is agreed upon after the negotiation process
* targetPrice: price during the truck/load creation, this value is NOT updated after negotiation
*/
import Trans from 'next-translate/Trans'
import useTranslation from 'next-translate/useTranslation'
import { useState } from 'react'
import ShipperCurrency from 'tennders-common/components/ShipperCurrency'
import GCurrency from 'tennders-market/common/components/element/GCurrency'
import GHref from 'tennders-market/common/components/element/GHref'
import { LoadTruck } from 'tennders-common/enums/LoadTruck'
import CarrierCurrencyComponent from 'tennders-common/components/CarrierCurrency'
import { isNil } from 'lodash'
import { dispatchUpdatePaymentTerms } from 'tennders-common/stores/modal/action'
import { useDispatch } from 'react-redux'

const TargetPrice = ({ item, t }) => (
  <>
    {item.priceType}
    :
    <strong>
      {' '}
      <GCurrency value={item.targetPrice} />
    </strong>
    <br />
    {t('transaction:paymentTerms')}:
    {` ${item.paymentTerm?.type || ''} `}
    {` / ${item.paymentTerm?.days || '?'} days`}
    {` / ${item.paymentTerm?.dType ? t('common:' + item.paymentTerm?.dType) : ''}`}
    {` / ${item.paymentTerm?.cmrType?.label || ''}`}
  </>
)

const BookRate = ({ bookRate, transaction, isAbout }) => {
  const [editable, setEditable] = useState(false)
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const updatePaymentTerms = (transaction) => dispatch(dispatchUpdatePaymentTerms(transaction))

  if (isNil(bookRate)) {
    return (
      <div className="text-12 mb-10">
        <Trans i18nKey="transaction:targetPrice" />{': '}
        <TargetPrice item={isAbout === LoadTruck.load ? transaction.matchedLoad : transaction.matchedTruck} t={t} />
      </div>
    )
  }

  return (
    <div className="text-12 mb-10">
      <Trans i18nKey="transaction:priceAgreed" />{': '}
      {isAbout === LoadTruck.load ? (
        <ShipperCurrency
          editable={editable}
          label={() => <b>S{' '}</b>}
          setEditable={setEditable}
          transaction={transaction}
        />
      ) : (
        <CarrierCurrencyComponent
          editable={editable}
          setEditable={setEditable}
          transaction={transaction}
          carrierShipperLabel={() => <b>C{' '}</b>}
        />
      )}
      {!transaction.disabledActions?.includes('UPDATE_BOOK_RATE') ? (
        <div>
          <GHref
            className="btn-link text-underline"
            onClick={() => ((isAbout === LoadTruck.truck || (isAbout === LoadTruck.load && !transaction?.isMarketPlaced))
              ? setEditable(!editable)
              : updatePaymentTerms(transaction)
            )}
          >
            {t('transaction:updateBookRate')}
          </GHref>
        </div>
      ) : null}
    </div>
  )
}

export default BookRate
